import { IconType, SvgIcon } from './SvgIcon.tsx';

export const ConnectisTabletLogo: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 30 18">
    <g clipPath="url(#clip0_557_41060)">
      <mask id="mask0_557_41060" maskUnits="userSpaceOnUse" x="0" y="0" width="17" height="18">
        <path d="M0 0.24588H16.8679V17.5901H0V0.24588Z" fill="white" />
      </mask>
      <g mask="url(#mask0_557_41060)">
        <path
          d="M12.6574 14.6376C13.745 13.8982 14.508 12.8468 14.9457 11.4844L16.8679 11.9333C16.3452 13.6772 15.3588 15.056 13.9094 16.0696C12.4593 17.0831 10.7563 17.5901 8.80103 17.5901C6.33924 17.5901 4.25683 16.7512 2.55451 15.0737C0.851498 13.3955 0 11.3431 0 8.9173C0 6.49215 0.851498 4.44039 2.55451 2.76293C4.25683 1.08478 6.33924 0.24588 8.80103 0.24588C10.7394 0.24588 12.4382 0.748312 13.8967 1.75354C15.3545 2.75808 16.3459 4.09943 16.8679 5.77758L14.9457 6.32588C14.5248 4.99665 13.766 3.95817 12.67 3.21117C11.574 2.46348 10.2841 2.08955 8.80103 2.08955C6.89567 2.08955 5.28961 2.74638 3.98284 4.0583C2.67607 5.37092 2.02339 6.99061 2.02339 8.9173C2.02339 10.8281 2.67607 12.4439 3.98284 13.7641C5.28961 15.0851 6.89567 15.7464 8.80103 15.7464C10.2848 15.7464 11.5698 15.3763 12.6574 14.6376Z"
          fill="white"
        />
      </g>
      <path
        d="M28.5066 17.5894H17.6674C17.4554 17.5894 17.252 17.5059 17.1021 17.3582C16.9522 17.2104 16.8679 17.01 16.8679 16.8011C16.8679 16.5921 16.9522 16.3918 17.1021 16.244C17.252 16.0963 17.4554 16.0135 17.6674 16.0135H28.5066C28.7186 16.0135 28.922 16.0963 29.0719 16.244C29.2219 16.3918 29.3061 16.5921 29.3061 16.8011C29.3061 17.01 29.2219 17.2104 29.0719 17.3582C28.922 17.5059 28.7186 17.5894 28.5066 17.5894Z"
        fill="#00FF8B"
      />
    </g>
    <defs>
      <clipPath id="clip0_557_41060">
        <rect width="30" height="18" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);
